import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold text-onyx">{title}</h1>
        {description && <p className="mt-1 text-sm text-onyx/60">{description}</p>}
      </div>
      {actions}
    </div>
  );
}
